import { Outlet } from "react-router-dom";

import { useIsAuthenticated } from "@azure/msal-react";

import styles from "./pageLayout.module.css";
import Navbar from "../NavBar";
import GenericExpandablePanel from "../GenericExpandablePanel";
import ExpandedNavItems from "../NavBar/ExpandedNavItems";
import OutsideAlerter from "../NavBar/OutsideAlerter";
import { PanelId, usePanelContext } from "../../context/PanelContext";

export const PageLayout = () => {
	const isAuthenticated = useIsAuthenticated();
	const { expandedPanel, setExpandedPanel } = usePanelContext();

	const handleOutsideClick = () => {
		setExpandedPanel(null);
	};

	return (
		<div className={styles.container}>
			<div className={styles.navbar}>
				<Navbar />
			</div>
			{expandedPanel === PanelId.Navigation && (
				<OutsideAlerter
					onOutsideClick={handleOutsideClick}
					excludedElementId={PanelId.Navigation}
				>
					<GenericExpandablePanel>
						<ExpandedNavItems isAuthenticated={isAuthenticated} />
					</GenericExpandablePanel>
				</OutsideAlerter>
			)}
			<div className={styles.content}>
				<Outlet />
			</div>
		</div>
	);
};
